"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuButtonStyled = exports.MenuCategoryStyled = exports.linkStyles = exports.LabelStyled = exports.CategoryListItemStyled = exports.CategoryStyled = exports.ContainerStyled = exports.SubCategoryList = exports.LineStyled = exports.ToTopButtonStyled = exports.ColumnLinksStyled = exports.ContentColStyled = exports.MenuColStyled = exports.MenuWrapStyled = exports.SidebarLinkStyled = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _const = require("@dbi-tools/ui-kit/lib/const");

var _list = require("@dbi-tools/ui-kit/lib/components/list");

var _container = require("@dbi-tools/ui-kit/lib/components/container");

var _helpers = require("../../helpers");

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  font-size: 12px;\n  line-height: 18px;\n  padding: 7.5px 0;\n\n  ", ";\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  font-size: 18px;\n  line-height: 27px;\n  font-weight: ", ";\n\n  ", ";\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: none;\n  color: ", ";\n  &:visited {\n    color: ", ";\n  }\n\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  font-size: 11px;\n  line-height: 15px;\n  font-weight: ", ";\n  text-transform: uppercase;\n  margin-bottom: 15px;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  :not(:last-child) {\n    padding-bottom: 15px !important;\n\n    ", " {\n      &:after {\n        content: '';\n        position: absolute;\n        left: -15px;\n        right: -15px;\n        bottom: 15px;\n        height: 1px;\n        background-color: ", ";\n      }\n    }\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 30px;\n  img {\n    max-width: 100%;\n    margin-bottom: 15px;\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    padding: 60px 27px;\n    padding-bottom: ", ";\n    padding-top: ", ";\n\n    ", " {\n      padding: 30px 24px;\n      padding-bottom: ", ";\n      padding-top: ", ";\n    }\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n\n  ", " {\n    display: ", ";\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  margin: 30px 0;\n  border-bottom: 1px solid ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  font-size: 14px;\n  line-height: 21px;\n  font-weight: ", ";\n  letter-spacing: unset;\n  text-decoration: underline;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  ", " {\n    margin-bottom: 20px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        padding-top: 42px;\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    position: sticky;\n    top: 50px;\n    padding-top: 15px;\n    z-index: 1;\n    background: ", ";\n  }\n  ", " {\n    top: 80px;\n    padding-top: 30px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    position: sticky;\n    top: 100px;\n    bottom: 20px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  margin-bottom: 10px;\n\n  ", " {\n    margin-bottom: 5px;\n  }\n\n  a {\n    display: inline-flex;\n    align-items: center;\n    text-align: left;\n    border-bottom: 1px solid transparent;\n    line-height: 15px;\n    &:hover {\n      border-color: ", ";\n      color: ", ";\n      * {\n        fill: ", " !important;\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SidebarLinkStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject(), _const.GridBreakpointsMediaDown.sm, _uiKit.Colors.gray800, _uiKit.Colors.gray800, _uiKit.Colors.gray800);
exports.SidebarLinkStyled = SidebarLinkStyled;
var MenuWrapStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject2(), _const.GridBreakpointsMediaUp.lg);
exports.MenuWrapStyled = MenuWrapStyled;
var MenuColStyled = (0, _uiKit.styled)(_uiKit.Col)(_templateObject3(), _const.GridBreakpointsMediaDown.lg, _uiKit.Colors.white, _const.GridBreakpointsMediaDown.md);
exports.MenuColStyled = MenuColStyled;
var ContentColStyled = (0, _uiKit.styled)(_uiKit.Col)(_templateObject4(), _const.GridBreakpointsMediaUp.lg, function (_ref) {
  var withAsideButton = _ref.withAsideButton;
  return withAsideButton && (0, _uiKit.css)(_templateObject5());
});
exports.ContentColStyled = ContentColStyled;
var ColumnLinksStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject6(), function (_ref2) {
  var theme = _ref2.theme;
  return theme && (0, _helpers.getTheme)(theme);
}, _const.GridBreakpointsMediaDown.lg);
exports.ColumnLinksStyled = ColumnLinksStyled;
var ToTopButtonStyled = (0, _uiKit.styled)(_uiKit.Button)(_templateObject7(), _uiKit.FontWeightValue.light);
exports.ToTopButtonStyled = ToTopButtonStyled;
var LineStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject8(), _uiKit.Colors.gray300);
exports.LineStyled = LineStyled;
var SubCategoryList = (0, _uiKit.styled)(_list.ListStyled)(_templateObject9(), _const.GridBreakpointsMediaDown.lg, function (_ref3) {
  var isCollapsed = _ref3.isCollapsed;
  return isCollapsed ? 'block' : 'none';
});
exports.SubCategoryList = SubCategoryList;
var ContainerStyled = (0, _uiKit.styled)(_container.Container)(_templateObject10(), function (_ref4) {
  var removeTopPadding = _ref4.removeTopPadding,
      removeBottomPadding = _ref4.removeBottomPadding;
  return (0, _uiKit.css)(_templateObject11(), removeBottomPadding ? 0 : '60px', removeTopPadding ? 0 : '60px', _const.GridBreakpointsMediaDown.sm, removeBottomPadding ? 0 : '30px', removeTopPadding ? 0 : '30px');
});
exports.ContainerStyled = ContainerStyled;
var CategoryStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject12());
exports.CategoryStyled = CategoryStyled;
var CategoryListItemStyled = (0, _uiKit.styled)(_list.ListItemStyled)(_templateObject13(), _const.GridBreakpointsMediaDown.lg, _uiKit.Colors.gray300);
exports.CategoryListItemStyled = CategoryListItemStyled;
var LabelStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject14(), _uiKit.FontWeightValue.bold);
exports.LabelStyled = LabelStyled;
var linkStyles = (0, _uiKit.css)(_templateObject15(), _uiKit.Colors.gray800, _uiKit.Colors.gray800, _uiKit.Colors.primaryDark);
exports.linkStyles = linkStyles;
var MenuCategoryStyled = (0, _uiKit.styled)('a')(_templateObject16(), _uiKit.FontWeightValue.bold, linkStyles);
exports.MenuCategoryStyled = MenuCategoryStyled;
var MenuButtonStyled = (0, _uiKit.styled)('a')(_templateObject17(), linkStyles);
exports.MenuButtonStyled = MenuButtonStyled;